import React from 'react';
import { BRAND, isMarketGB } from '../../../constants/main';
import { BasketPaymentDetailsAC } from './AC/BasketPaymentDetails.AC';
import { BasketPaymentDetailsOV } from './OV/BasketPaymentDetails.OV';
import { BasketPaymentDetailsAP } from './AP/BasketPaymentDetails.AP';
import { BasketPaymentDetailsDS } from './DS/BasketPaymentDetails.DS';
import { BasketPaymentDetailsOV as BasketPaymentDetailsOV_GB } from './OV/GB/BasketPaymentDetails.OV';
import { BasketPaymentDetailsStyled } from './BasketPaymentDetailsStyled';
import { SC } from '../../../styles/theme';

export type BasketPaymentDetailsProps = SC & {
    generatedIndex?: number;
};

const BasketPaymentDetails = (props: BasketPaymentDetailsProps) => {
    if (BRAND === 'AC') return <BasketPaymentDetailsAC {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? <BasketPaymentDetailsOV_GB {...props} /> : <BasketPaymentDetailsOV {...props} />;
    if (BRAND === 'AP') return <BasketPaymentDetailsAP {...props} />;
    if (BRAND === 'DS') return <BasketPaymentDetailsDS {...props} />;
    return <BasketPaymentDetailsStyled {...props} />;
};

export default BasketPaymentDetails;
